import React from 'react';
import { Link } from 'react-router';
import pages from '../../../subscriber/Pages';
import { getArray } from '../../../utils/helpers';
import { getIconComponent } from '../../../utils/iconHelper';
import poachedEgg from '../../../assets/top_view_round_fish_meat.png';
import HomePageVideo from '../../../assets/videos/home_page_hero.mp4';


const HeroSection = ({t}) => {
    const { social_media } = pages || {};
    
    const SocialIcon = ({ Icon, link = "#" }) => (
        <a
            href={link}
            target="_blank"
            rel="noopener"
            className="text-[#FFF] text-accent hover:text-accent-dark flex self-end"
            onMouseEnter={(e) => {
                e.currentTarget.style.color = 'rgb(211, 117, 43)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.color = '#FFF';
            }}
        >
            <Icon size={30} className='my-2' />
        </a>
    );

    const PageLink = ({link, text}) => (
        <Link
            to={link}
            className="border py-2 px-5 rounded-md transition duration-300 text-[2rem] md:text-[2rem] font-bold text-white font-['__Libre_Caslon_Display_7cf3ab']"
            style={{
                borderWidth: 0,
                color: '#FFF',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgb(211, 117, 43)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
            }}
        >
            {text}
        </Link>
    )

    return (
        <section className="relative w-full h-[80vh] md:h-[100vh] overflow-hidden flex flex-col items-center justify-center">
            {/* Background video */}
            <video
                autoPlay
                loop
                muted
                playsInline
                className="absolute top-0 left-0 w-full h-full object-cover z-0"
            >
                <source src={HomePageVideo} type="video/mp4" />
                {t?.video}
            </video>

            {/* Overlay to ensure text is readable */}
            <div className="absolute inset-0 bg-black opacity-50 z-10"></div>

            <div className="container mx-auto px-4 relative z-20 flex flex-col flex-1 justify-around">
                <div className="flex flex-col md:flex-row">
                    <div className="w-full md:w-1/2 mb-10 md:mb-0">
                        <h5 className="text-white __libre-caslon-display text-xl mb-2">{t?.chef_name}</h5>
                        <h1 className="__libre-caslon-display text-4xl md:text-5xl mb-5 text-white">{t?.experience}</h1>
                        <div className="relative">
                            <h1 className="__libre-caslon-display text-4xl md:text-5xl mb-6 text-white inline-block ml-[25%]">{t?.subMeg}</h1>
                            <img 
                                src={poachedEgg}
                                alt="Poached egg dish"
                                width={230}
                                height={230}
                                style={{transform: 'translateX(-45%) translateY(-20%) rotate(0deg)'}}
                                className="absolute top-1/2 
                                    w-[80px] h-[80px]
                                    sm:w-[80px] sm:h-[80px] 
                                    md:w-[120px] md:h-[120px] 
                                    lg:w-[230px] lg:h-[230px] 
                                    rounded-full object-cover 
                                    transform -translate-x-1/2 -translate-y-1/2 
                                    animate-zoom-display-home-mobile md:animate-zoom-display-home-desktop"
                            />
                        </div>
                        <div className="mt-0 sm:mt-4 max-w-[376px] ml-[19%]">
                            <p className="text-gray-300 italic font-normal text-center">
                                &quot; {t?.message} &quot;.
                            </p>
                            <div className='mt-0 sm:mt-4 flex flex-col sm:flex-row'>
                                <PageLink link={`/blogs`} text={t?.blog} />
                                <PageLink link={`/services`} text={t?.services} />
                            </div>
                        </div>
                    </div>
                    <div className="w-full md:w-1/2 flex justify-end items-center">
                        {/* Content for the right column */}
                        <div className="flex-col">
                            {getArray(social_media).map((link, index) => {
                                const IconComponent = getIconComponent(link.key);
                                return (
                                    IconComponent && <SocialIcon key={index} Icon={IconComponent} link={link.value} />
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className='container mx-auto relative z-10 mb-2 flex justify-center'>
                <div className="w-full md:w-1/4 mb-10 md:mb-0 flex flex-row justify-between">
                    <PageLink link="" text="text 3" />
                    <PageLink link="" text="text 4" />
                </div>
            </div> */}
        </section>
    );
};

export default HeroSection;
